// src/components/PanelControl.js
import React from 'react';
import AvisoManagement from './AvisoManagement';

const PanelControl = ({ user, onLogout }) => {
    
    return (
        <div className="panel-container" style={{ background: '#ffffff', minHeight: '100vh' }}>
            {/* Ya no necesitamos el header viejo aquí, porque el Navbar 
                profesional lo incluimos dentro de AvisoManagement.
            */}
            
            <main className="panel-main-content">
                {/* PASAMOS LAS PROPS: 
                   Le entregamos 'user' y 'onLogout' que vienen desde App.js 
                */}
                <AvisoManagement user={user} onLogout={onLogout} /> 
            </main>
        </div>
    );
};

export default PanelControl;